import { render, staticRenderFns } from "./V2ProductWishlistsDropdown.vue?vue&type=template&id=6145f698&scoped=true&"
import script from "./V2ProductWishlistsDropdown.vue?vue&type=script&lang=js&"
export * from "./V2ProductWishlistsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./V2ProductWishlistsDropdown.vue?vue&type=style&index=0&id=6145f698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145f698",
  null
  
)

export default component.exports